'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrimaryLineStyled = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = function style(_ref) {
  var themeFromProvider = _ref.theme,
      customThickness = _ref.customThickness;

  var componentTheme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider).reactackle.components.progress;

  var strokeSize = componentTheme.circle.strokeSize;


  return (0, _styledComponents.css)(['stroke-width:', ';'], (0, _reactackleCore.getValueString)(customThickness || strokeSize));
};

var strokeAnimation = function strokeAnimation(_ref2) {
  var themeFromProvider = _ref2.theme,
      circleLength = _ref2.circleLength,
      indeterminate = _ref2.indeterminate;

  var animationConfig = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider).reactackle.components.progress.circle.animation.circle;

  var animation = (0, _styledComponents.keyframes)(['0%{stroke-dasharray:', ' ', ';stroke-dashoffset:', ';}50%{stroke-dasharray:', ' ', ';stroke-dashoffset:', ';}100%{stroke-dasharray:', ' ', ';stroke-dashoffset:', ';}'], 0.02 * circleLength, circleLength, 0 * -circleLength, 0.75 * circleLength, circleLength, 0 * -circleLength, 0.75 * circleLength, circleLength, 1 * -circleLength);

  var duration = animationConfig.transitionDuration;


  return !indeterminate ? null : (0, _styledComponents.css)(['animation:', 'ms ', ' ease-in-out infinite;'], duration, animation);
};

var PrimaryLineStyled = exports.PrimaryLineStyled = _styledComponents2.default.circle.withConfig({
  displayName: 'PrimaryLineStyled'
})(['fill:none;stroke-dasharray:0 158;transform-origin:center;', ' ', ''], strokeAnimation, style);

PrimaryLineStyled.displayName = 'PrimaryLineStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-progress/dist/CircleProgress/styles/PrimaryLineStyled.js
// module id = 761
// module chunks = 0